import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import './themes/generated/dx.material.material-blue-light.css';
import Vue from "vue";

import App from "./App";
import router from "./router";
import appInfo from "./app-info";
import store from "./store"; //Vuex
import VueResource from 'vue-resource';

/* AJT ToDo - Get a valid clientId, set it, Uncomment this block of code
/*import GoogleAuth from '../src/config/google_oAuth.js'

const gauthOption = {
clientId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
}

Vue.use(GoogleAuth, gauthOption)*/

Vue.use(VueResource);

Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;

new Vue({
  router,
  store, //Vuex
  render: h => h(App)
}).$mount("#app");

//Global Parameters
Vue.mixin({
  data: function() {
    return {
      //thisIsaGlobalVarPOC: "It works",
    }
  },
  methods:{
    //getData(){
    //  shared.getData();
    //}
  }
})